export default "\n\n<iframe height=\"99%\" width=\"100%\" frameborder=\"0\" srcdoc=\"{{data.BODY}}\"></iframe>"